import { SessionSystemType } from "doxecure-commons/lib/doxecureModelTypes";

import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { NewSessionView } from "@containers/newSession/NewSessionView";

const NewTemplateSessionPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="newTemplate">
            <NewSessionView systemType={SessionSystemType.Template} />
        </AuthenticatedLayout>
    );
}

export default NewTemplateSessionPage;